export const focusDelay = 200;

export const uploadDownloadAPITypes = {
  ATTACHMENTS: "ATTACHMENTS",
  CONVERSATION_ATTACHMENTS: "CONVERSATION_ATTACHMENTS",
  LIVE_CHAT_INBOX_ATTACHMENTS: "LIVE_CHAT_INBOX_ATTACHMENTS",
  MARKETING_UPLOADS: "MARKETING_UPLOADS",
};

export const fileSizeUnits = {
  B: "B",
  KB: "KB",
  MB: "MB",
  GB: "GB",
  TB: "TB",
};

export const bytesInUnit = {
  [fileSizeUnits.B]: 1,
  [fileSizeUnits.KB]: 1024,
  [fileSizeUnits.MB]: 1024 ** 2,
  [fileSizeUnits.GB]: 1024 ** 3,
  [fileSizeUnits.TB]: 1024 ** 4,
};
